import * as constants from './walkthru-constants';

export const resetWalkThru = () => (
  {
    type: constants.RESET,
  }
);

export const closeWalkThru = () => (
  {
    type: constants.CLOSE,
  }
);
export const openWalkThru = () => (
  {
    type: constants.OPEN,
  }
);

export const setProductTourSteps = (steps, eventName) => (
  {
    type: constants.SET_STEPS,
    payload: {
      steps,
      eventName,
    },
  }
);



// WEBPACK FOOTER //
// ./src/app/stores/ui/components/walkthru/walkthru-actions.js